import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { GameRecordForm } from '../model/form';
import { FirestoreUser, GameRecord, IContextSetting, IshowSubFormGR, NetworkConstants, deepCopy} from 'diwimamodelweb/lib'
import { UserFeedbackService } from '../user-feedback.service';
import { contextIdsFromRights } from '../context-rights-picker/context-rights-picker.component';
import { ContextAccess, changedGeoFields, coordKey, isGeoLocked, isReadOnly, resolveContextAccess } from '../context-rights-picker/context-access';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { GamerecordService } from '../gamerecord.service';
import { GameOriginFormDialogComponent } from '../game-origin-form-dialog/game-origin-form-dialog.component';
import { SettingsService } from '../settings.service';
import { AuthService } from '../auth.service';
import {UserService} from './../user.service'
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GameRecordWebtsnDialogComponent } from '../game-record-webtsn-dialog/game-record-webtsn-dialog.component';
import { firstValueFrom, skipWhile, take } from 'rxjs';

function notANumber(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const value: string|undefined = control.value
    let nV = value
    if (typeof value == 'string') {
      nV = value.replace(',', '.')
    }
    return (Number.isNaN(Number(nV)) && !control.pristine) ? {notANumber: true} : null;
  };
}

@Component({
  selector: 'app-gamerecord-form-base',
  templateUrl: './gamerecord-form-base.component.html',
  styleUrls: ['./gamerecord-form-base.component.css', '../../app.component.scss']
})
export class GamerecordFormBaseComponent implements OnInit {

  @Input() data: GameRecordForm
  @Input() formBuilder: FormBuilder
  @Input() userFeedbackService: UserFeedbackService
  @Input() translateService: TranslateService
  @Output() showSubForm: EventEmitter<IshowSubFormGR> = new EventEmitter()
  @Output() showSubListItemForm: EventEmitter<string> = new EventEmitter()
  @Input() gameService: GamerecordService

  gameRecordFormBase: FormGroup
  gameRecordImages:any = []
  gameRecordImagesDocData:any = []
  dropdownStatus: any[]
  dropdownLocation: any[]
  dropdownHuntingMethod: any[]
  species: IContextSetting

  displayDataErlegerBtn: any
  displayDataHuntignDistrictBtn: any
  displayDataLabSampleBtn:any = []
  meatQualityOptions: any[]
  shotQualityOptions: any[]
  utilizationOptions: any[]
  displayPlannedUtilization: any = {title: "Geplanter Verwertungsweg"}
  displayHuntingEvent: any = {title: "Jagd-Ereignis"}

  showPostMortemComment = false
  showHasShotPrice = false
  attatchments = []
  allPrintTemplatesByName = []
  printLablesGameRecord = []
  user:FirestoreUser = new FirestoreUser
  idToShow:string
  diwima_adis_module = false
  laboratorySamples:any

  hi_tier:any
  nvTrichinella:any
  wildart:any
  district:any

  grUpdateRight = false
  grDeleteRight = false
  contextAccess: ContextAccess = 'owner'

  get isViewOnly(): boolean { return isReadOnly(this.contextAccess) }
  get isGeoLocked(): boolean { return isGeoLocked(this.contextAccess) }
  get canSave(): boolean {
    return !this.isViewOnly && this.grUpdateRight && !this.gameRecordFormBase?.invalid
  }
  get canDelete(): boolean {
    return this.grDeleteRight && this.contextAccess === 'owner' && !this.gameRecordFormBase?.invalid
  }

  private static readonly GEO_SUB_FORMS = ['districts', 'placeOfKilling', 'hunterLocation']
  private static readonly GEO_FIELDS = ['placeOfKilling', 'hunterLocation', 'huntingDistrictId']
  private geoSnapshot: Record<string, any> = {}

  constructor( private gameRecordService : GamerecordService,
    private settingsService:SettingsService,
    private authService: AuthService,
    private userService: UserService,
    private actRouter: ActivatedRoute,
    private router: Router,
    private userFeddback: UserFeedbackService
    ) { 
      this.actRouter.params.subscribe( value => {
        this.idToShow = value.identifier
      })
    }

  async ngOnInit(): Promise<void> {
    this.userService.user$.pipe().subscribe(value=> {
      this.user.setFromAny(value)
    })

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe( skipWhile(el => !el), take(1) ))
    this.hi_tier = context.modulesMap?.get('hi-tier') ? true : false
    this.nvTrichinella = context.modulesMap?.get('nvTrichinella') ? true : false

    const rights = this.settingsService.rightsPercontext.get(context.identifier)

    this.grUpdateRight = !!rights?.[NetworkConstants.COLLECTION_GAMERECORD]?.['U']
    this.grDeleteRight = !!rights?.[NetworkConstants.COLLECTION_GAMERECORD]?.['D']

    
    this.dropdownLocation = (this.data.constextSettings.get(NetworkConstants.SETTING_GR_LOCATION) as IContextSetting).values
    this.dropdownStatus = (this.data.constextSettings.get(NetworkConstants.SETTING_GR_STATUS) as IContextSetting).values
    this.dropdownHuntingMethod = (this.data.constextSettings.get(NetworkConstants.SETTING_HUNTING_METHODS) as IContextSetting).values 
    this.meatQualityOptions = (this.data.constextSettings.get(NetworkConstants.SETTING_GR_MEAT_QUALITY) as IContextSetting).values as any[]
    this.shotQualityOptions = (this.data.constextSettings.get(NetworkConstants.SETTING_GR_SHOT_QUALITY) as IContextSetting).values as any[]
    this.utilizationOptions = (this.data.constextSettings.get(NetworkConstants.SETTING_UTILIZATION_OPTION) as IContextSetting).values as any[]

    this.species = this.data.constextSettings.get(NetworkConstants.SETTING_SPECIES)
    this.diwima_adis_module = this.data.constextModules.get(NetworkConstants.MODULES_DWM_ADIS) ? true : false
    // shot and meat qual
    if(this.data.data.pictureURLlinks)
      this.gameRecordImages = this.data.data.pictureURLlinks

    if(this.data.data.wildart)
      this.wildart = this.data.data.wildart

    try{
      this.attatchments = this.gameRecordService.getAttachmentsFilesGameRecord(this.data.data.identifier)
    }catch(error){}

    if(this.data.data?.meatQuality) {
      const ind = this.meatQualityOptions.findIndex((el) => el.identifier == this.data.data?.meatQuality)
      // if (ind != -1) this.displayMeatQualityBtn.selectedValue = this.meatQualityOptions[ind].title
      if (ind == -1) this.meatQualityOptions.push(
        {
          identifier: this.data.data?.meatQuality,
          title: this.data.data?.meatQuality,
          sortIndex: 0
        }
      )
    }

    if(this.data.data?.shotQuality) {
      const ind = this.shotQualityOptions.findIndex((el) => el.identifier == this.data.data?.shotQuality)
      // if (ind != -1) this.displayShotQualityBtn.selectedValue = this.shotQualityOptions[ind].title
      if (ind == -1) this.shotQualityOptions.push(
        {
          identifier: this.data.data?.shotQuality,
          title: this.data.data?.shotQuality,
          sortIndex: 0
      }
      )
    }
    if(this.data.data?.plannedUtilization) {
      // const ind = this.utilizationOptions.findIndex((el) => el.identifier == this.data.data?.plannedUtilization)
      // if (ind != -1) this.displayPlannedUtilization.selectedValue = this.utilizationOptions[ind].title
      // else if (ind == -1) this.displayPlannedUtilization.selectedValue = this.data.data?.plannedUtilization
      const txt = this.data.data?.getPlannedUtilizationTitle()
      let t = txt ? txt : ""
      if (this.data.data?.plannedUtilizationDetails) t += " " + this.data.data.plannedUtilizationDetails?.personName
      this.displayPlannedUtilization.selectedValue = t 
    }

    this.gameRecordFormBase = this.formBuilder.group({
      tagid: [],
      officialGameTag: [{value: undefined, disabled: true}],
      erlegeArt: [],
      killingDate: [new Date()],
      killingTime: [''],
      ageInYears: [, [notANumber()]],
      status: [],
      currentLocationID: [],
      currentLocationTitle: [],
      postMortemInspectionRequired: [],
      postMortemInspectionComment: [],
      dressedPreliminary: [, [notANumber()]],
      salesAsWholeBody: [, [notANumber()]],
      comment: [],
      postingAccount: [],
      hasShootPrice:[],
      shootPrice: [, [notANumber()]],
      receiptNo: [],
      meatQuality: [],
      shotQuality:[],
      webTSNobject:[],
      contextIdRights: [{}]
    })
    if (this.data.data) this.initilizeWithData()
    // disable uuid input
    this.gameRecordFormBase.controls.tagid.disable()

    const subIds = this.settingsService.getSubcontextIds() // ?? (context as any)?.subContextIds
    this.contextAccess = resolveContextAccess(
      this.data.data as any,
      context?.identifier,
      subIds,
    )
    this.geoSnapshot = this.readGeoFields(deepCopy(this.data.data, this.data.data?.replacerFn))
    if (this.isViewOnly) this.gameRecordFormBase.disable({ emitEvent: false })

    this.gameRecordFormBase.get('contextIdRights')?.valueChanges.subscribe((rights: any) => {
      if (!this.data?.data) return
      const ids = contextIdsFromRights(rights)
      ;(this.data.data as any).contextIdRights = ids.length ? rights : undefined
      ;(this.data.data as any).contextIds      = ids.length ? ids : undefined
    })

    this.gameRecordFormBase.valueChanges.subscribe(() => {
      const value = this.gameRecordFormBase.getRawValue()
      const {
        killingDate, 
        killingTime, 
        postMortemInspectionRequired, hasShootPrice,webTSNobject
      } = value
      this.showHasShotPrice = hasShootPrice
      this.showPostMortemComment = postMortemInspectionRequired ? postMortemInspectionRequired : false
      var el = {...value}
     
      delete el.contextIdRights
      delete el.contextIds
      // set timestamp value from input
      const d = new Date(killingDate.getTime())
      const split = killingTime.split(':')
      if (split.length != 3) return 
      const hours = +split[0]
      const minutes = +split[1]
      const seconds = +split[2]
      d.setHours(hours)
      d.setMinutes(minutes)
      d.setSeconds(seconds)
      el.timeStamp = d
      // parse all number fields... 
      const {
        dressedPreliminary, salesAsWholeBody,
        shootPrice, ageInYears
      } = value
      el['weights'] = {}
      if (dressedPreliminary) {
        delete el.dressedPreliminary
        el.weights.dressedPreliminary = dressedPreliminary
      }
      if (salesAsWholeBody) {
        delete el.salesAsWholeBody
        el.weights.salesAsWholeBody = salesAsWholeBody
      }
      if (dressedPreliminary && typeof dressedPreliminary == 'string') {
        delete el.dressedPreliminary
        let nV = dressedPreliminary.replace(',', '.')
        const number = Number(nV)
        if (!Number.isNaN(number)) el.weights['dressedPreliminary'] = number
      }
      if (salesAsWholeBody && typeof salesAsWholeBody == 'string') {
        delete el.salesAsWholeBody
        let nV = salesAsWholeBody.replace(',', '.')
        const number = Number(nV)
        if (!Number.isNaN(number)) el.weights['salesAsWholeBody'] = number
      }
      if (Object.keys(el.weights).length == 0) el.weights = undefined
      if (shootPrice && typeof shootPrice == 'string') {
        delete el.shootPrice
        let nV = shootPrice.replace(',', '.')
        const number = Number(nV)
        if (!Number.isNaN(number)) el['shootPrice'] = number
      }
      if (ageInYears && typeof ageInYears == 'string') {
        delete el.ageInYears
        let nV = ageInYears.replace(',', '.')
        const number = Number(nV)
        if (!Number.isNaN(number)) el['ageInYears'] = number
      }
      this.data.data.setFromAny(el)
      if (!hasShootPrice) {
        this.data.data.shootPrice = undefined
        this.data.data.receiptNo = undefined
        this.gameRecordFormBase.controls.shootPrice.setValue(undefined, {emitEvent: false})
        this.gameRecordFormBase.controls.receiptNo.setValue(undefined, {emitEvent: false})
      }
      if (!el.postMortemInspectionRequired) {
        this.data.data.postMortemInspectionComment = undefined
        this.gameRecordFormBase.controls.postMortemInspectionComment.setValue(undefined, {emitEvent: false})
      }
    })
    // this.gameService.createGameRecord(this.data.data)
    if(this.gameRecordService.printTemplatesGameRecordsSubject$.value)
    this.allPrintTemplatesByName = this.gameRecordService.printTemplatesGameRecordsSubject$.value
    else{
      this.printLablesGameRecord = this.gameRecordService.getPrintTemplatesGameRecord()
    }

    this.gameRecordService.printTemplatesGameRecordsSubject$.subscribe( value => {
      this.allPrintTemplatesByName = value
    })

    this.gameRecordService.gameRecordAttatchmentsSubject$.subscribe( value=> {
      this.attatchments = value.filter( file => file.gameRecordId === this.data.data.identifier || file.gameRecordId === this.idToShow)
    })


    this.gameRecordService.gameRecordpictureURLlinksDocSubject$.subscribe( value => {
      if(value[this.idToShow])
      this.gameRecordImagesDocData = value[this.idToShow]
    })
  }

  reloadAttatchments(){
    try{
       this.gameRecordService.getAttachmentsFilesGameRecord(this.data.data.identifier)

      this.gameRecordService.gameRecordAttatchmentsSubject$.subscribe( value=> {
        this.attatchments = []
        this.attatchments = value
      })
    }catch(error){}
  }

  async initilizeWithData() {
    const {
      tagid,
      officialGameTag,
      erlegeArt,
      timeStamp,
      ageInYears,
      status,
      currentLocationID,
      currentLocationTitle,
      postMortemInspectionRequired,
      postMortemInspectionComment,
      weights,
      comment,
      hasShootPrice,
      shootPrice,
      receiptNo,
      postingAccount,
      meatQuality,
      shotQuality,
      webTSNobject,
      laboratorySamples,
      statusTitle
    } = this.data.data as GameRecord

    // for date and time 
    let time: string|undefined = undefined
    let date: Date|undefined = undefined
    if (timeStamp) {
      time = `${(timeStamp.getHours()<10?'0':'')+timeStamp.getHours()}:${(timeStamp.getMinutes()<10?'0':'') + timeStamp.getMinutes()}:${(timeStamp.getSeconds()<10?'0':'')+timeStamp.getSeconds()}`;
      date = timeStamp;
    }
    this.gameRecordFormBase.patchValue({
      tagid,
      officialGameTag,
      erlegeArt,
      killingDate: date,
      killingTime: time,
      ageInYears,
      status: status ? status : undefined,
      statusTitle: statusTitle ? statusTitle : undefined,
      currentLocationID,
      currentLocationTitle,
      postMortemInspectionRequired,
      postMortemInspectionComment,
      comment,
      dressedPreliminary: weights?.dressedPreliminary,
      salesAsWholeBody: weights?.salesAsWholeBody,
      postingAccount,
      hasShootPrice,
      meatQuality,
      shotQuality,
      shootPrice,
      receiptNo,
      webTSNobject,
      laboratorySamples,
      contextIdRights: (this.data.data as any)?.contextIdRights ?? {}
    })

    this.gameRecordFormBase.get('status')?.valueChanges.subscribe( value => {
      let statustitle = this.dropdownStatus?.find(st =>  st.identifier === status)?.title
      this.gameRecordFormBase.patchValue({statusTitle: statustitle})
    })

    this.gameRecordFormBase.get('currentLocationID')?.valueChanges.subscribe( value => {
      const title = this.dropdownLocation.find(d => d.identifier == value)?.title
      if (title) this.gameRecordFormBase.patchValue({currentLocationTitle: title})
    })

    if (hasShootPrice) this.showHasShotPrice = true
    if (postMortemInspectionRequired) this.showPostMortemComment = true
    if (laboratorySamples){
      laboratorySamples.forEach((labs, index) => {
        this.displayDataLabSampleBtn[index] = {
          title: labs.type,
          iconName: 'icon_doc-text_search',
          selectedValue: labs.state ?? "",
          examinations: labs.examinations ?? []
        }
      });
      this.laboratorySamples = laboratorySamples
    }

    // display data btn erleger
    const person_ind = this.data.person.findIndex(el => el.identifier == this.data.data?.erlegerId)
    let erlegerName: string|undefined = this.data.data?.erlegerAnzeigeName
    if (!erlegerName && person_ind != -1) erlegerName = this.data.person[person_ind].anzeigeName
    // if (!erlegerName && this.data.data?.erlegerAnzeigeName != undefined) erlegerName = this.data.data.erlegerAnzeigeName
    this.displayDataErlegerBtn = {
      title: erlegerName,
      iconName: 'icnSchuetze',
      selectedValue: ""
    }
    const district_ind = this.data.huntingDistricts.findIndex(el => el.identifier == this.data.data?.huntingDistrictId)
    this.district = this.data.huntingDistricts[district_ind]
    let districtName: string|undefined = this.data.data?.huntingDistrictName
    if (!districtName && district_ind != -1) districtName = this.data.huntingDistricts[district_ind].name    
    // if (!districtName && this.data.data?.huntingDistrictName != undefined) districtName = this.data.data.huntingDistrictName
    const district_title = this.translateService.instant('FORM.gameRecordForm.btn_district_select')
    this.displayDataHuntignDistrictBtn = {
      title: district_title,
      selectedValue: districtName
    }

    const event_ind = this.data.events.findIndex(el => el.identifier == this.data.data?.eventId)
    let eventName: string|undefined = this.data.data?.eventName
    if (!eventName && event_ind != -1) eventName = this.data.events[district_ind]?.name    
    // if (!eventName && this.data.data?.eventName != undefined) eventName = this.data.data.eventName
    const event_title = this.translateService.instant('FORM.gameRecordForm.btn_event_select')
    this.displayHuntingEvent = {
      title: event_title,
      selectedValue: eventName
    }
    // this.gameService.createGameRecord(this.data.data)
  }

  onSubmit() {
    if (!this.canSave) return

    if (this.isGeoLocked) {
      const changed = changedGeoFields(
        this.geoSnapshot,
        this.readGeoFields(this.data.data),
        GamerecordFormBaseComponent.GEO_FIELDS,
      )
      if (changed.length) {
        this.userFeedbackService.showSnackBar.emit('Geodaten können nicht geändert werden.')
        return
      }
    }

    this.data.onSubmit()

  }

  private readGeoFields(record: any): Record<string, any> {
    return {
      placeOfKilling:    coordKey(record?.placeOfKilling?.location),
      hunterLocation:    coordKey(record?.hunterLocation?.location),
      huntingDistrictId: record?.huntingDistrictId ?? null,
    }
  }

  isGeoSubForm(subForm: string): boolean {
    return GamerecordFormBaseComponent.GEO_SUB_FORMS.includes(subForm)
  }

  isSubFormLocked(subForm: string): boolean {
    return this.isViewOnly || (this.isGeoLocked && this.isGeoSubForm(subForm))
  }

  async displayInfo(path: string, options: any[]) {
    const dialogTitle = await this.translateService.instant(path)
    let message = ""
    options.forEach((el) => {
      const {comment, title} = el
      if (title && comment) {
        message += `
          <h4>${title}</h4>
          <p>${comment}</p>
        `
      }
    })
    this.userFeedbackService.showDialog.emit(
      {
        entryComponent: GenericDialogComponent,
        title: dialogTitle,
        message: message != "" ? message : "No Information",
      }
    )
  }

  subFormHandle(subForm: string, dataTodisplay?:any) {
    if (this.isSubFormLocked(subForm)) {
      const only_modified_original = this.translateService.instant('only_modified_original')
      const property_only_view = this.translateService.instant('property_only_view')
      this.userFeedbackService.showSnackBar.emit(
        this.isViewOnly
          ? property_only_view
          : only_modified_original,
      )
      return
    }
    let data = {
      contextSettings: this.data.constextSettings,
      contextModules: this.data.constextModules,
      data: dataTodisplay
    }
    this.showSubForm.emit({subForm, data})
  }

  showLocation(location: firebase.default.firestore.GeoPoint) {
    if (!location) return 
    const url = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`
    window.open(url, "_blank")
  }

  formatNumber(number): string {
    return Number.parseFloat(number).toFixed(3)
  }

  async onDelete(){
    if (!this.canDelete) return
    const title = this.translateService.instant('delete_title')
    const message = this.translateService.instant('delete_message') 
    this.userFeedbackService.loading.emit(false)
    this.userFeedbackService.showDialog.emit(
      {
        entryComponent: GenericDialogComponent,
        title: title,
        message: message,
        cancleCallback: async ()=> {
          const sbCancelDelete = this.translateService.instant('delete_canceled')
          this.userFeedbackService.showSnackBar.emit(sbCancelDelete)
        },
        positiveCallback: async ()=>{
          try{
            this.userFeedbackService.loading.emit(true)
            const sbSuccessDelete = this.translateService.instant('delete_completed')
            
            await this.data.onDelete()
            this.userFeedbackService.loading.emit(false)
            this.userFeedbackService.showSnackBar.emit(sbSuccessDelete)
            // this.data.onCancle()
          }catch(errorDelete){
            console.log(errorDelete)
            const sbErrorDelete = this.translateService.instant('delete_error')
            this.userFeedbackService.showSnackBar.emit(sbErrorDelete)
          }
        } 
      }
    )


  }

  checkMissingUserData(){
    const {firstName, lastName, email, legalAddress, telephone, signature } = this.user
    const {city, country, zip, address1} = legalAddress ?? {}

    return (firstName && lastName && email && telephone && signature && address1 && city && country && zip) ? true : false
  }

  async onGameOriginForm(){ 
    const title = this.translateService.instant('gameOriginForm_title')
    this.userFeedbackService.loading.emit(false)

    if(!this.checkMissingUserData()){
      const title = this.translateService.instant("ERROR.missing_data")
      const message = this.translateService.instant("FORM.gameRecordForm.gameOriginCertificate_missing_user_data")

      this.userFeedbackService.showDialog.emit({
        entryComponent: GenericDialogComponent,
        title: title,
        message: message != "" ? message : "No Information",
        positiveCallbackBtnLabel: this.translateService.instant('FORM.gameRecordForm.gameOriginCertificate_edit_contact_details'),
        cancleCallback: async ()=> { },
        positiveCallback: async (data)=>{
          this.router.navigate(['cockpit', this.settingsService.selectedUserContext$.value.identifier, 'objects','User', this.user.identifier])
        }
      })
    }else{
      this.userFeedbackService.showDialog.emit({
        entryComponent: GameOriginFormDialogComponent,
        title: title,
        message: '',
        data:{
          templates:  this.allPrintTemplatesByName ?? this.printLablesGameRecord ,
          values: this.data.data,
          form:this.gameRecordFormBase.value
        },
        cancleCallback: async ()=> { },
        positiveCallback: async (data)=>{
          const name = data?.template?.name?.split('.zip')
          let dataToSend = {
            contextId: this.settingsService.selectedUserContext$.value?.identifier, //String,
            template: name[0],//String,
            gameRecordId: this.data?.data?.identifier,//String,
            formData: data?.formData ?? {},///[String:String], // (aka Map or Dictionary)
            user: this.user//FirestoreUser,  // (The User as stored in Firestore)
          }
          try{           
            await this.gameRecordService.addCreateGameOriginForm(dataToSend)
            setTimeout(() => {
            this.reloadAttatchments()
            }, 2000);

          }catch(errorDelete){
            console.log(errorDelete)
            const sbErrorDelete = this.translateService.instant('delete_error')
            this.userFeedbackService.showSnackBar.emit(sbErrorDelete)
          }
        } 
      })
    }
  }

  openImage(im, index){
    window.open(im.resourceId, '_blank').focus();
  }

  deleteImg(im, index){
    const dataToDelete = this.gameRecordImagesDocData?.find( img => img.identifier.includes(im.fileName) || img.identifier === `preview_${im.fileName}.jpg`)
    const title = this.translateService.instant("delete_title")
    const message = this.translateService.instant("delete_message")
    this.userFeddback.showDialog.emit({
        entryComponent: GenericDialogComponent,
        title,
        message,
        positiveCallback: async ()=> {          
          this.userFeddback.loading.emit(true)
          let files = []
          if(dataToDelete){
            if(dataToDelete.identifier.includes('preview_'))
            files = [im.fileName, `preview_${im.fileName}.jpg`]
            else
            files = [im.fileName]

            this.gameRecordService.deleteFilesStorage(files, this.idToShow,dataToDelete ).then( value => {
              if(value){
                this.gameRecordImages.splice(index, 1)
                this.userFeddback.loading.emit(false)
              }else{
                console.error('Error deleting one or more files:');
                const message = this.translateService.instant("delete_error")
                this.userFeddback.showSnackBar.emit(message)
                this.userFeddback.loading.emit(false)
              }
            })
          }
        },

        cancleCallback: () => { 
          this.userFeddback.loading.emit(false)
        }
      }
    )
  }

  onReportWebTSN(){
    const gameRecordForm = this.gameRecordFormBase.value
    const gameRecord = deepCopy(this.data.data)
    let baseURL = `https://test.tsn.fli.de/fa/so`
    const projectId = environment?.firebaseConfig?.projectId 

    // if(projectId == "diwima-de-prod")
    //   baseURL = `https://prod.tsn.fli.de/fa/so`
    
    //build url
    const ags = gameRecordForm.placeOfKilling?.ags ? gameRecordForm.placeOfKilling?.ags : gameRecord.placeOfKilling?.ags
    const geom_x = gameRecord.placeOfKilling?.location?.longitude
    const geom_y = gameRecord.placeOfKilling?.location?.latitude

    if((gameRecordForm.placeOfKilling?.ags || gameRecord.placeOfKilling?.ags) && geom_x && geom_y && gameRecord.age){

      const krs_ags = ags.substring(0,5)  
      const ts_schl = "011"
      const wildtier = "1"
      let tierarten = ""
  
      switch(gameRecord.age){
        case 'Frischlingskeiler':{
          tierarten = encodeURI("105300|3-301,6-603^1")
          break;
        }
        case 'Frischlingsbache':{
          tierarten = encodeURI("105300|3-301,6-603^1")
          break;
        }
        case 'Überläuferbache':{
          tierarten = encodeURI("105300|3-302,4-401,6-607^1")
          break;
        }
        case 'Überläuferkeiler':{
          tierarten = encodeURI("105300|3-302,4-402,6-607^1")
          break;
        }
        case 'Keiler':{
          tierarten = encodeURI("105300|4-401^1")
          break;
        }
        case 'Bache':{
          tierarten = encodeURI("105300|4-402^1")
          break;
        }
      }
  
      const url = `${baseURL}?krs_ags=${krs_ags}&ts_schl=${ts_schl}&wildtier=${wildtier}&geom_x=${geom_x}&geom_y=${geom_y}&tierarten=${tierarten}`
      //open url in new tab
      window.open(url, '_blank')
      //open dialog to save code
      const title = this.translateService.instant("FORM.gameRecordForm.Web_TSN_Object_Key")
      this.userFeddback.showDialog.emit({
        entryComponent: GameRecordWebtsnDialogComponent,
        title,
        message: '',
        positiveCallback: async (webTSNobject)=> { 
          this.gameRecordFormBase.patchValue({webTSNobject})
          //save GameRecord.webTSNobject after close dialog
          this.onSubmit()
        }
      })

    }else{
      const message = "ERROR.missing_data"
      this.userFeddback.showSnackBar.emit(message)
    }

  }
  //hiTierState
  get anyLSskippedSubmission(){ return this.laboratorySamples ? this.laboratorySamples.some(lab=> lab.nvState === "skippedSubmission" || lab.hiTierState === "skippedSubmission" ) : false }
  get allLSskippedSubmission(){ return this.laboratorySamples ? this.laboratorySamples.every(lab=> lab.nvState === "skippedSubmission" || lab.hiTierState === "skippedSubmission" ) : false }
  get checkAllGreen() { return this.laboratorySamples ? this.laboratorySamples.every(lab => lab.nvState === "certificateCreated" || lab.nvState === "receivedResult" || lab.hiTierState === "certificateCreated" || lab.hiTierState === "receivedResult") : false}
  get checkAnyYellow() { return this.laboratorySamples ? this.laboratorySamples.some(lab => lab.nvState === "pendingResults" || lab.nvState === "pendingResult" 
                                                                                          || lab.nvState === "certificatePending" 
                                                                                          || lab.hiTierState === "pendingResults" || lab.hiTierState === "pendingResult" 
                                                                                          || lab.hiTierState === "certificatePending") : false}
  get checkAnyRed() { return this.laboratorySamples ? this.laboratorySamples.some(lab => lab.nvState === "skippedSubmission" || lab.nvState === "submissionFailed" 
                                                                                      || lab.nvState === "certificateFailed" || lab.nvState === "authenticationFailed" || lab.nvState === "sampleRejected" || 
                                                                                          lab.hiTierState === "skippedSubmission" || lab.hiTierState === "submissionFailed" 
                                                                                          || lab.hiTierState === "certificateFailed" || lab.hiTierState === "authenticationFailed" 
                                                                                          || lab.hiTierState === "sampleRejected"
                                                                                          || lab.nvState === "pendingSubmission" || lab.hiTierState === "pendingSubmission" 
                                                                                          ) : false}

  get checkAnyPendingSubmission() {
    return this.laboratorySamples ? this.laboratorySamples.some(lab => lab.nvState === "pendingSubmission" || lab.hiTierState === "pendingSubmission"  ) : false
  }

  get checkAuthFailed() { return this.laboratorySamples ? this.laboratorySamples.some(lab =>  lab.nvState === "authenticationFailed" || lab.hiTierState === "authenticationFailed") : false}
  get checkSampleRejected() { return this.laboratorySamples?.some(lab =>  lab.nvState === "sampleRejected" || lab.hiTierState === "sampleRejected" ) ?  this.laboratorySamples?.find(lab =>  lab.nvState === "sampleRejected" || lab.hiTierState === "sampleRejected" ) :  false}
}
